<template>
  <BackendUploaderBase
    ref="uploader"
    v-bind="{ multiple, accept, autoUpload, url, factory, capture, disable, category }"
    hide-upload-btn
    no-thumbnails
    flat
    class="invisible-uploader"
    @start="$emit('start')"
    @finish="$emit('finish')"
    @added="$emit('added', $event)"
    @uploaded="$emit('uploaded', $event)"
  >
    <template #header="scope">
      <slot name="btn" v-bind="{ triggerProps: uploaderAddTriggerProps }">
        <q-btn
          v-bind="btnProps"
          :loading="disable || scope.isBusy || scope.isUploading"
          :disable="disable"
        >
          <q-uploader-add-trigger v-bind="uploaderAddTriggerProps" />
          <slot />
        </q-btn>
      </slot>
    </template>

    <template #list="scope">
      <div />
    </template>
  </BackendUploaderBase>
</template>

<script>
import { Platform } from 'quasar'

import BackendUploaderBase from 'components/partials/uploader/BackendUploaderBase'
import componentMixin from 'components/partials/uploader/componentMixin'

export default {
  components: {
    BackendUploaderBase
  },
  mixins: [componentMixin],
  props: {
    btnProps: {
      type: Object,
      default: () => {
        return {
          label: Platform.is.mobile ? 'Take Photo' : 'Upload Photo',
          icon: 'mdi-camera',
          color: 'blue-grey'
        }
      }
    }
  },
  emits: ['start', 'finish', 'uploaded', 'added'],
  computed: {
    isPhotoCapture () {
      return this.capture === 'camera'
    },
    uploaderAddTriggerProps () {
      return {
        'accept': this.isPhotoCapture ? 'image/*' : undefined,
        'capture': this.isPhotoCapture ? 'environment' : undefined
      }
    }
  }
}
</script>
